/* eslint-disable */
import { base, baseUpload, baseXlsx } from '@/utils/api'

const HEALTH_PLAN_PROPS_ENDPOINT = '/item-other-expense-props'

export default {
    getItemOtherExpenseProp(id) {
        const config = {
            params: { clinicHealthPlanId }
        };
        return base.get(`${HEALTH_PLAN_PROPS_ENDPOINT}/${id}`, config);
    },
    getOtherExpensePropItems(page, tableId, query, types, status) {
        const config = {
            params: { page, tableId, query, types, status }
        };
        return base.get(`${HEALTH_PLAN_PROPS_ENDPOINT}`, config);
    },
    getItemOtherExpensePropIds(tableId) {
        const config = {
            params: { tableId }
        };
        return base.get(`${HEALTH_PLAN_PROPS_ENDPOINT}/batch/ids`, config);
    },
    createItemOtherExpenseProp(props) {
        return base.post(`${HEALTH_PLAN_PROPS_ENDPOINT}`, props);
    },
    updateItemOtherExpenseProp(id, props) {
        return base.put(`${HEALTH_PLAN_PROPS_ENDPOINT}/${id}`, props);
    },
    deleteItemOtherExpenseProp(id) {
        return base.delete(`${HEALTH_PLAN_PROPS_ENDPOINT}/${id}`);
    },
    deleteItemOtherExpenseProps(ids) {
        return base.put(`${HEALTH_PLAN_PROPS_ENDPOINT}/batch/delete`, { ids });
    },
    updateExtraFieldsSimpro(simproPropId, data) {
        return base.put(`/simpro/${simproPropId}`, data)
    },
    updateExtraFieldsBrasindice(brasindicePropId, data) {
        return base.put(`/brasindice/${brasindicePropId}`, data)
    },
}